<template>
  <div class="modal fade" id="categoriaModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span v-if="isEditing && categoria?.descripcion">Editar: {{ categoria.descripcion }}</span>
            <span v-else>Agregar Categoría</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm">
            
            <div class="form-group">
              <label>Código</label>
              <input v-model="form.codigo" type="text" 
                class="form-control text-uppercase" 
                :class="{'is-invalid': errors.codigo}"
                placeholder="EJ: CAT-001" 
                :disabled="isEditing" />
              <div class="invalid-feedback">{{ errors.codigo }}</div>
              <small v-if="isEditing" class="text-muted">El código no puede ser modificado para preservar la integridad.</small>
            </div>

            <div class="form-group">
              <label>Descripción / Nombre</label>
              <input v-model="form.descripcion" type="text" 
                class="form-control text-uppercase" 
                :class="{'is-invalid': errors.descripcion}"
                placeholder="EJ: BEBIDAS ENERGÉTICAS" />
              <div class="invalid-feedback">{{ errors.descripcion }}</div>
            </div>

            <div class="form-group">
              <label>Proveedor Asociado</label>
              <select v-model="form.proveedor_id" class="form-control" 
                :class="{'is-invalid': errors.proveedor_id}" 
                :disabled="isEditing">
                <option value="" disabled>Seleccione un proveedor</option>
                <option v-for="prov in proveedoresFiltrados" :key="prov.id" :value="prov.id">
                  {{ prov.descripcion }} {{ !prov.estatus ? '(INACTIVO)' : '' }}
                </option>
              </select>
              <div class="invalid-feedback">{{ errors.proveedor_id }}</div>
              <small v-if="isEditing" class="text-muted">La relación con el proveedor es permanente.</small>
            </div>

            <div class="modal-footer px-0 pb-0 mt-4">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
              <button type="submit" class="btn btn-primary">
                {{ isEditing ? "Actualizar" : "Guardar" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { alert } from "@/plugins/alert.js";
import { loading } from "@/plugins/loading.js";

export default {
  props: ['categoria', 'proveedores'],
  data() {
    return {
      form: this.getDefaultForm(),
      errors: {}
    };
  },
  computed: {
    isEditing() { 
      return !!(this.categoria && this.categoria.id); 
    },
    // Al crear, solo permitimos proveedores activos. Al editar, mostramos todos para que no falle el select.
    proveedoresFiltrados() {
      if (this.isEditing) return this.proveedores;
      return this.proveedores.filter(p => p.estatus == true);
    }
  },
  watch: {
    categoria: {
      immediate: true,
      handler(newVal) {
        this.errors = {};
        if (newVal && newVal.id) {
          this.form = { 
            ...newVal,
            codigo: newVal.codigo || "",
            descripcion: newVal.descripcion || "",
            proveedor_id: newVal.proveedor_id || ""
          };
        } else {
          this.form = this.getDefaultForm();
        }
      }
    }
  },
  methods: {
    getDefaultForm() {
      return { codigo: "", descripcion: "", proveedor_id: '' };
    },
    async submitForm() {
      this.errors = {};
      
      // Validaciones básicas de Frontend
      const descVal = (this.form.descripcion || "").trim();
      if (descVal.length < 3) this.errors.descripcion = "La descripción es demasiado corta.";
      if (!this.isEditing && !this.form.codigo) this.errors.codigo = "El código es requerido.";
      if (!this.form.proveedor_id) this.errors.proveedor_id = "Debe seleccionar un proveedor.";

      if (Object.keys(this.errors).length > 0) {
        return alert.toast({ title: 'Verifica los campos', icon: 'warning' });
      }

      try {
        loading.show('Procesando categoría...');
        
        // El payload solo necesita la descripción si es un update (según tu controlador)
        const payload = {
          descripcion: descVal.toUpperCase(),
          ...( !this.isEditing && { 
            codigo: this.form.codigo.trim().toUpperCase(),
            proveedor_id: this.form.proveedor_id 
          })
        };

        if (this.isEditing) {
          await api.put(`/categoria/${this.categoria.id}`, payload);
        } else {
          await api.post("/categoria", payload);
        }

        loading.hide();
        alert.toast({ title: '¡Categoría guardada!', icon: 'success' });
        this.$emit("success");
        window.$("#categoriaModal").modal("hide");

      } catch (error) {
        loading.hide();
        
        // Captura los errores específicos del controlador (422: Padre Inactivo / Solo lectura)
        const serverMsg = error.response?.data?.message || 'Error al procesar';
        const serverDetail = error.response?.data?.detalles || '';
        
        alert.toast({ 
          title: serverMsg, 
          text: serverDetail,
          icon: 'error',
          timer: 6000 
        });

        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
        }
      }
    }
  }
};
</script>